import {createAppComponent} from '@tfx/common/initializers'
import {store} from '../store/index'
import dialogsMixins from './modules/dialogs-mixins'

export class VueComponent {
  perform(list = undefined) {
    Array.from(document.querySelectorAll('[tfx-component="vue-component"]')).forEach((el) => {
      if (el.dataset.initialized !== 'true') {
        el.dataset.initialized = 'true'
        try {
          const comp = createAppComponent({
            store,
            mixins: [dialogsMixins]
          })
          comp.mount(el)
          if (Array.isArray(list)) list.push(comp)
        } catch (e) {
          console.error(e, el) // eslint-disable-line
        }
      }
    })
  }
}

const vueComponent = new VueComponent()
export default vueComponent
